<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">Upload Rute Delivery</div>
      <div v-if="loading == true">
        <loading></loading>
      </div>
      <div class="card-body">
        <div v-if="loading == false">
          <b-form id="uploadSpkbIndomaretForm" validated novalidate>
            <b-row>
              <b-col sm="4">
                <b-form-group label-for="file" label="Upload Rute">
                  <b-form-file
                    ref="inputDocument"
                    accept=".xls, .xlsx, .csv"
                    @change="OnUploadSelect($event)"
                    required
                  ></b-form-file>
                  <div
                    v-if="uploadSpkbIndomaretForm.file === null || uploadSpkbIndomaretForm.file === undefined"
                    class="invalid-feedback-custom"
                  >Upload rute untuk membuat SPKB.</div>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>

          <div slot="modal-footer" class="float-right">
            <b-button
              type="button"
              size="sm"
              variant="primary"
              @click="processUpload"
              :disabled="$v.uploadSpkbIndomaretForm.$invalid"
            >
              <i class="fa fa-save"></i> Save
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import interfaces from "@/templates/_interfaces.js";
import loading from "@/templates/Loading.vue";
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "spkb_indomaret",
  props: {
    flag: {
      type: Boolean,
      default: false
    }
  },
  components: {
    loading
  },
  data() {
    return {
      uploadListExcell: ["xls", "xlsx", "csv"],
      loading: false,
      uploadSpkbIndomaretForm: interfaces.upload_generate_form
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  validations: {
    uploadSpkbIndomaretForm: {
      file: { required }
    }
  },
  methods: {
    resetForm: function() {
      this.loading = false;
      //this.$refs["inputDocument"].reset();
      this.uploadSpkbIndomaretForm.file = null;
    },
    OnUploadSelect: function(event) {
      if (event.target.files.length > 0) {
        const file = event.target.files[0];
        const fileArray = file.name.split(".");
        const totalArray = fileArray.length - 1;
        if (this.uploadListExcell.includes(fileArray[totalArray])) {
          this.uploadSpkbIndomaretForm.file = event.target.files[0];
        } else {
          this.resetForm();
        }
      } else {
        this.resetForm();
      }
    },
    processUpload: function(evt) {
      alert("Pastika data yang anda masukkan adalah benar");
      if (confirm("Apakah anda yakin ingin memproses data ini?")) {
        this.loading = true;
        let uploadOrder = new FormData();
        uploadOrder.append("file", this.uploadSpkbIndomaretForm.file);
        this.axios
          .post("web/generate/upload-rute-indomaret/", uploadOrder)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Tambah SPKB",
                message: response.data.message
              });
            }
            this.handleSubmit();
          })
          .catch(error => {
            this.expired(error, "Upload SPKB");
          })
          .finally(() => {
            this.resetForm();
          });
      }
    }
  }
};
</script>

<style>
</style>
